import { render } from "./AddDonationPayment.vue?vue&type=template&id=96a6ea2a"
import script from "./AddDonationPayment.vue?vue&type=script&lang=js"
export * from "./AddDonationPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__